import React, { useMemo, useState } from 'react';
import * as columns from '../../misc/Columns';
import { Dialog, Button, DialogActions } from '@mui/material';
import { NewOrEdit } from '../NewOrEdit.tsx';

interface NewDialogProps {
    columns: columns.ColumnInfo[];
    lovs: Record<string, any>;
    onHandleAdd: (data: Record<string, string | number | boolean>) => Promise<void>;
    onHandleClose: () => void;
}

function filterAndHideIdColumn(columns: columns.ColumnInfo[]): columns.ColumnInfo[] {
    return columns
        .filter((col) => col.type !== 'action')
        .map((col) => (col.id === 'id' ? { ...col, hidden: true } : col));
}

function initializeNewData(columns: columns.ColumnInfo[]): Record<string, string | number | boolean> {
    const rec: Record<string, string | number | boolean> = {};
    columns.forEach((col) => {
        rec[col.id] = '';
    });
    return rec;
}

export function NewDialog({
    columns,
    lovs,
    onHandleAdd,
    onHandleClose,
}: NewDialogProps): JSX.Element {
    const columnsForNew = useMemo(() => filterAndHideIdColumn(columns), [columns]);
    const [newData, setNewData] = useState<Record<string, string | number | boolean>>(initializeNewData(columnsForNew));

    return (
        <Dialog onClose={onHandleClose} open={true} fullWidth={true} maxWidth="lg">
            <NewOrEdit
                rowData={newData}
                columns={columnsForNew}
                changedData={setNewData}
                lovs={lovs}
            />
            <DialogActions>
                <Button onClick={onHandleClose}>Close</Button>
                <Button onClick={() => onHandleAdd(newData)} autoFocus>
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function getColumns(columns: columns.ColumnInfo[]): columns.ColumnInfo[] {
    return filterAndHideIdColumn(columns);
}